module.exports = __webpack_public_path__ + "static/mobile-02e8ca7328018474aca458d197a86cd4.svg";